import type { DispatchReportItemDto } from "@/api/dtos";
import type { DispatchReportItem } from "@/api/report/_models/DispatchReport";
import { emptyToNull } from "./utils";

/** DTO → domain for a dispatch row: carrier/tracking grouped into `tracking`, empty optional strings → null. */
export const toDispatchReportItemFromDto = (
  dto: DispatchReportItemDto,
): DispatchReportItem => {
  return {
    company: dto.company,
    consignmentNumber: dto.consignmentNumber,
    item: dto.item,
    description: emptyToNull(dto.description),
    date: dto.date,
    orderReference: dto.orderReference,
    quantity: dto.quantity,
    tracking: {
      carrier: dto.carrier,
      number: dto.trackingNumber,
      url: emptyToNull(dto.trackingUrl),
    },
  };
};
